import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "form-item" }
const _hoisted_3 = { class: "date-list-item add-item-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "help is-danger"
}

import Toast from '@/shared/services/toast';
import Modal from '@/shared/components/Modal.vue';
import { CREATE_HOLIDAY } from '@/store/holidays/actionTypes';
import { HolidayViewModel } from '@/features/bots/models/holidayViewModel';
import VuelidateUtil from '@/shared/util/vuelidateUtil';
import { useStore } from 'vuex';
import { nextTick, onMounted, ref } from 'vue';
import { required, maxLength } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import NTextInput from '@/shared/designsystem/components/input/text-input/text-input.vue';
import HolidayDateInput from './HolidayDateInput.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateHoliday',
  emits: ["create", "cancel"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const createHoliday = (request: HolidayViewModel): Promise<HolidayViewModel> => store.dispatch(CREATE_HOLIDAY, request);

const name = ref('');
const dates = ref<any[]>([{ date: new Date(), key: 'first' }]);
const updateInProgress = ref(false);

const nameInput = ref<InstanceType<typeof NTextInput> | null>(null);
const dateInputs = ref<InstanceType<typeof HolidayDateInput>[]>([]);

const emit = __emit;

const validations = {
  name: {
    required,
    maxLength: maxLength(50),
    holidayNameValid: VuelidateUtil.objectName,
  },
  dates: {
    required,
  },
};

const $v = useVuelidate(validations, { name, dates });

onMounted(() => focusOnInput(nameInput.value));

function closeModal() {
  emit('cancel');
}

function addDate() {
  dates.value.push({ date: new Date(), key: Date.now() });
  nextTick(() => {
    if (dateInputs.value) {
      const lastDateInput = dateInputs.value[dateInputs.value.length - 1];
      focusOnInput(lastDateInput);
    }
  });
}

function deleteDate(index: number) {
  dates.value.splice(index, 1);
}

function getErrorMessage(prop: 'name' | 'dates', label: string): string | null {
  if (!VuelidateUtil.hasPropertyBeenTouched($v, prop)) {
    return null;
  }

  return VuelidateUtil.getErrorMessage($v, prop, label, (failedRule) => {
    if (prop === 'name' && VuelidateUtil.isValidationInvalid($v, prop, 'holidayNameValid')) {
      return `${label} must only contain letters, numbers, spaces, and the characters , - _ ( ) &`;
    }
    return null;
  });
}

async function update() {
  if (updateInProgress.value) {
    return;
  }

  updateInProgress.value = true;
  try {
    const request = createRequestModel();
    const createdHoliday = await createHoliday(request);
    Toast.showSuccess('Holiday successfully created');
    emit('create', createdHoliday);
  } catch (err: any) {
    Toast.showError(err.message);
  } finally {
    updateInProgress.value = false;
  }
}

function createRequestModel(): HolidayViewModel {
  return {
    name: name.value,
    dates: dates.value.map((d) => d.date),
  };
}

function focusOnInput(component?: InstanceType<typeof NTextInput> | InstanceType<typeof HolidayDateInput> | null) {
  if (component) {
    const inputElements = component.$el.getElementsByTagName('input');
    if (inputElements.length === 1) {
      inputElements[0].focus();
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createBlock(Modal, { onCancel: closeModal }, {
    title: _withCtx(() => _cache[3] || (_cache[3] = [
      _createElementVNode("p", { class: "modal-card-title" }, "Add Holiday", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("fieldset", null, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(NTextInput, {
            ref_key: "nameInput",
            ref: nameInput,
            modelValue: name.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
            label: "Name",
            id: "name",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref($v).name.$touch())),
            "error-message": getErrorMessage('name', 'Name')
          }, null, 8, ["modelValue", "error-message"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", null, [
            _cache[4] || (_cache[4] = _createTextVNode(" On ")),
            _createVNode(_component_n_tooltip, {
              position: "right",
              text: "Previously added holidays now in the past will automatically be removed"
            })
          ])
        ]),
        _createElementVNode("ul", null, [
          _createVNode(_TransitionGroup, { name: "fade" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dates.value, (d, index) => {
                return (_openBlock(), _createBlock(HolidayDateInput, {
                  key: d.key,
                  modelValue: dates.value[index].date,
                  "onUpdate:modelValue": [
                    ($event: any) => ((dates.value[index].date) = $event),
                    _cache[2] || (_cache[2] = ($event: any) => (_unref($v).dates.$touch()))
                  ],
                  onDelete: ($event: any) => (deleteDate(index)),
                  ref_for: true,
                  ref_key: "dateInputs",
                  ref: dateInputs
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onDelete"]))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("li", _hoisted_3, [
            _createVNode(_component_n_button, {
              variant: "ghost",
              icon: "add",
              disabled: updateInProgress.value,
              onClick: addDate
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode(" Add Date ")
              ])),
              _: 1
            }, 8, ["disabled"]),
            (!_unref($v).dates.required)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "You must add at least one date"))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_n_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            variant: "primary",
            disabled: _unref($v).$invalid,
            loading: updateInProgress.value,
            onClick: update
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode(" Create Holiday ")
            ])),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_n_button, {
            disabled: updateInProgress.value,
            onClick: closeModal
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("Cancel")
            ])),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})